<template>
  <div class="flex flex-col gap-4 py-4">
    <h2 class="text-title-large md:text-headline-large flex grow flex-row items-center gap-0.5">
      {{ $t('settings.organization') }} <BaseIcon>chevron_right</BaseIcon>
      {{ $t('settings.feedbackTopics.title') }}
    </h2>

    <div class="flex flex-col gap-0.5">
      <ManageFeedbackTopicItem
        v-for="feedbackTopic in feedbackTopics"
        :key="feedbackTopic.id"
        :feedback-topic="feedbackTopic"
        @feedback-topic-enabled-updated="onSwitchUpdated"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import ManageFeedbackTopicItem from './ManageFeedbackTopicItem.vue'
  import type { OrganizationFeedbackTopicViewModel } from '../models/organization-feedback-topic'

  interface Props {
    feedbackTopics: ReadonlyArray<OrganizationFeedbackTopicViewModel>
  }

  defineProps<Props>()

  const emits = defineEmits<{
    (
      e: 'feedback-topic-enabled-updated',
      input: { feedbackTopicId: string; enabled: boolean },
    ): void
  }>()

  const onSwitchUpdated = (input: { feedbackTopicId: string; enabled: boolean }) => {
    emits('feedback-topic-enabled-updated', input)
  }
</script>
